import 'tailwindcss/dist/base.css'
import './src/components/layout.css'
